import React from "react";
import { useIntl } from "react-intl";
import SeoHead from "~/components/seo/SeoHead";

export default function VendorsPageSeo() {
  const intl = useIntl();

  return (
    <SeoHead
      title={intl.formatMessage({ defaultMessage: 'Local Government Innovation Vendors', id: 'wVOwCh' })}
      description={intl.formatMessage({ defaultMessage: 'Search local government technology vendors on Govlaunch.', id: 'vaL9LZ' })}
    />
  );
}
